<template>
  <div class="form-field cart-order-block__pickup-city-wrap">
    <label class="form-field__label texts texts_small texts_grey" v-if="label">
      {{ label }}
    </label>
    <div class="custom-select custom-select_single" :class="{_open: isOpened}" ref="customSelect">
      <div class="custom-select__inner">
        <div class="custom-select__field-wrapper">
          <input
              type="text"
              class="custom-select__field"
              :placeholder="isOpened ? 'Поиск' : ''"
              :value="searchInputValue"
              @click="open"
              :readonly="!isOpened"
              v-show="isOpened"
              @input="search"
              ref="searchInput"
          />
          <input
              type="text"
              class="custom-select__field"
              :value="selectedLabel || placeholder"
              @click="open"
              readonly
              v-show="!isOpened"
          />
          <div class="custom-select__arrow-icon custom-select__arrow-icon_absolute">
            <ArrowDown />
          </div>
        </div>
        <div class="custom-select__content-wrap" v-show="isOpened">
          <ul class="custom-select__list">
            <li v-if="!choices.length || (searchValue && filteredChoices.length === 0)">
              <div class="custom-select__no-choices">Нет результатов</div>
            </li>
            <li v-for="(choice, index) in filteredChoices" class="custom-select__item">
<!--              <label class="custom-select__label">-->
<!--                <input-->
<!--                    type="radio"-->
<!--                    :id="id(choice)"-->
<!--                    :value="choice.key"-->
<!--                    :disabled="choice.disabled"-->
<!--                    class="custom-select__input"-->
<!--                    v-model="internalValue"-->
<!--                    @change="handleRadioChange($event)"-->
<!--                />-->
<!--                <span class="custom-select__choice-name">{{ choice.label }}</span>-->
<!--              </label>-->

              <input
                  type="radio"
                  :id="id(choice, index)"
                  :value="choice.key"
                  :disabled="choice.disabled"
                  class="custom-select__input"
                  v-model="internalValue"
                  @change="handleRadioChange($event)"
              />
              <label :for="id(choice, index)" class="custom-select__label">
                <span class="custom-select__choice-name">
                  {{ choice.label }}
                </span>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowDown from "../../components/icons/ArrowDown.vue";

export default {
  name: "SelectSingleField",
  components: { ArrowDown },
  props: {
    label: {
      type: String,
      default: "",
    },
    choices: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "Выберите значение",
    },
  },
  data() {
    return {
      isOpen: false,
      searchValue: "",
      internalValue: this.modelValue,
    };
  },
  computed: {
    selectedLabel() {
      if (!this.internalValue) return null;
      const selectedChoice = this.choices.find((choice) => choice.key === this.internalValue);
      return selectedChoice ? selectedChoice.label : null;
    },
    filteredChoices() {
      let choices = this.choices || [];
      if (this.searchValue) {
        choices = choices.filter((choice) =>
            choice.label.toLowerCase().includes(this.searchValue.toLowerCase().trim())
        );
      }
      return choices;
    },
    searchInputValue() {
      return this.searchValue || "";
    },
    isOpened() {
      return this.isOpen;
    },
  },
  watch: {
    modelValue(newValue) {
      this.internalValue = newValue;
    },
    internalValue(newValue) {
      this.$emit("update:modelValue", newValue);
    },
  },
  methods: {
    id(choice) {
      return `select_${choice.key}_1`;
    },
    open() {
      this.isOpen = true;
      this.searchValue = "";
      setTimeout(() => {
        this.$refs.searchInput.focus();
      }, 100);
    },
    close() {
      this.isOpen = false;
    },
    search(e) {
      this.searchValue = e.target.value;
    },
    handleRadioChange(event) {
      if (!event || !event.target) {
        console.error("Invalid event object:", event);
        return;
      }
      const selectedKey = event.target.value;
      if (selectedKey === undefined || selectedKey === null) {
        console.error("Selected key is invalid:", selectedKey);
        return;
      }
      this.internalValue = selectedKey;
      this.$emit("update:modelValue", selectedKey);
      this.close();
    },
    validateAndSetInitialValue(choices, initialValue = this.internalValue) {
      if (!choices || !choices.length) return;
      const validChoice = choices.find((choice) => choice.key === initialValue);
      if (!validChoice && initialValue !== undefined) {
        this.internalValue = null;
      }
      if (!this.internalValue && this.placeholder) {
        this.internalValue = null;
      }
    },
  },
  mounted() {
    document.addEventListener("click", (e) => {
      const el = this.$refs.customSelect;
      if (this.isOpen && !(el === e.target || el.contains(e.target))) {
        this.close();
      }
    });
    this.validateAndSetInitialValue(this.choices, this.modelValue);
  },
  beforeUnmount() {
    document.removeEventListener("click", () => {});
  },
};
</script>